module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-400.woff2?f57a62e9efddf6ace18b15572f81905b";